import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { useSpecificationsUIContext } from "./SpecificationsUIContext";

export function SpecificationsGrouping({
  haveAccess = true,
  haveFullAccess,
  holiday = false,
  haveHardDelete = false,
  auditOption
}) {
  // Specs UI Context
  const specsUIContext = useSpecificationsUIContext();
  const specsUIProps = useMemo(() => {
    return {
      ids: specsUIContext.ids,
      openDeleteSpecificationsDialog:
        specsUIContext.openDeleteSpecificationsDialog,
      openFetchSpecificationsDialog:
        specsUIContext.openFetchSpecificationsDialog,
      openHolidaySpecificationsDialog:
        specsUIContext.openHolidaySpecificationsDialog,
      openAuditOptionSpecificationsDialog:
        specsUIContext.openAuditOptionSpecificationsDialog,
      openHardDeleteSpecificationsDialog:
        specsUIContext.openHardDeleteSpecificationsDialog
    };
  }, [specsUIContext]);

  const intl = useIntl();
  return (
    <div className="form">
      <div className="row align-items-center form-group-actions margin-top-20">
        <div className="col-xl-12">
          <div className="form-group form-group-inline">
            <div className="form-label form-label-no-wrap">
              <label className="font-bold font-danger mt-5">
                <span> {intl.formatMessage({ id: 'MODULES.GENERAL.SELECTEDRECORDSCOUNT' })}  {specsUIProps.ids.length}</span>
              </label>
            </div>
            <div className="form-group-inline">
              {haveAccess && <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={specsUIProps.openDeleteSpecificationsDialog}
              >
                <i className="fa fa-stream"></i>تغییر دسترسی
              </button>}
              &nbsp;
              {!holiday && haveFullAccess && <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={specsUIProps.openFetchSpecificationsDialog}
              >
                <i className="fa fa-stream"></i>تغییر نوع دسترسی
              </button>
              }
              &nbsp;
              {holiday && !haveFullAccess && <button
                type="button"
                className="btn btn-light-danger font-weight-bolder font-size-sm"
                onClick={specsUIProps.openHolidaySpecificationsDialog}
              >
                <i className="fa fa-calendar"></i>تغییر وضعیت کاری
              </button>
              }
              &nbsp;
              {auditOption && !haveFullAccess && <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={specsUIProps.openAuditOptionSpecificationsDialog}
              >
                <i className="fa fa-stream"></i>تغییر وضعیت دسترسی
              </button>
              }
              &nbsp;
              {haveHardDelete && !haveFullAccess && <button
                type="button"
                className="btn btn-light-danger font-weight-bolder font-size-sm"
                onClick={specsUIProps.openHardDeleteSpecificationsDialog}
              >
                <i className="fa fa-trash"></i>حذف قطعی
              </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
